export const createDisplayName =
    (parentDisplayName: string) => (displayName: string) =>
        `${parentDisplayName}.${displayName}`;

export default createDisplayName;
